import { Box, Chip, Typography } from '@mui/material';

import styles from '../styles';

type SectionsChangedCellProps = {
  sections: string[];
};

/** Read-only display of sections; editing happens in the Letter modal. */
const SectionsChangedCell = ({ sections }: SectionsChangedCellProps) => {
  const values = sections.filter(Boolean);

  if (values.length === 0) {
    return (
      <Typography variant='body2' color='text.secondary'>
        —
      </Typography>
    );
  }

  return (
    <Box sx={styles.sectionsChangedCell}>
      {values.map(section => (
        <Chip key={section} label={section} size='small' sx={styles.sectionsChangedChip} />
      ))}
    </Box>
  );
};

export default SectionsChangedCell;
